import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as expressionNode from '../../node'
import { Primitive } from '../primitive'

export type Node<T extends Primitive = Primitive> = expressionNode.ForValue<T>
export namespace Node {
  export const isNode: TypeChecker<Node> = TypeChecker.Factory.custom(
    (val: unknown): val is Node =>
      expressionNode.ForValue.isForValue(val) &&
      Primitive.isPrimitive(val.value),
    {
      typeDescription: 'dms.Primitive.Node',
    },
  )
  export const assertIsNode: TypeAsserter<Node> =
    TypeAsserter.Factory.from(isNode)
}
